export enum BASE_ROUTES {
  STARSEED_QUIZ = '/starseed-quiz',
  SOULMATE_SKETCH = '/soulmate-sketch',
  STARSEED_QUIZ_SECURED = '/3pSlZJAJhys02tLKp-iM2LQ',
  CHAKRA = '/nebula-chakra/prelanding',
  NUMEROLOGY = '/nebula-numerology/prelanding',
  DESTINY = '/nebula-destiny/prelanding',
  DREAMING = '/nebula-dreaming/prelanding',
  PALMISTRY = '/palmistry',
  NATAL_CHART = '/natal-chart',
  WITCH_POWER = '/witch-power',
  COMPATIBILITY = '/compatibility',
  SPIRITUAL = '/hypnotherapy/prelanding',
  MOON_COMPATIBILITY = '/moon-compatibility',
  TECH_TERMS = '/tech/terms',
  TECH_FAQ = '/tech/faq',
  TECH_CONTACT_US = '/tech/contact-us',
  TECH_PAYMENT_TERMS = '/tech/payment-terms',
  TECH_MONEY_BACK_POLICY = '/tech/money-back-policy',
  TECH_REFUND_POLICY = '/tech/refund-policy',
  TECH_SUBSCRIPTION_TERMS = '/tech/subscription-terms',
  TECH_IMPRESSUM = '/tech/impressum',
  TECH_LEGAL_CENTER = '/tech/legal-center',
  TECH_FULL_DISCLAIMER = '/tech/full-disclaimer',
  TECH_COOKIE_POLICY = '/tech/cookie-policy',
  PRIVACY_POLICY = '/tech/privacy-policy',
  HUMAN_DESIGN = '/human-design',
  WELLBEING = '/Kpm6ppQYijUl2t7A7Q',
  DRAFT = '/draft',
  HOME = '/',
}

export enum LANDINGS {
  TRIAL_CREDITS = '/trialCredits',
  ADDITIONAL_DISCOUNT = '/additionalDiscount',
  UPSELLS = '/upsells',
}
